import api from './client';

export const listCustomQuotes = (params = {}) =>
  api.get('/custom-quotes/admin', { params }).then(r => r.data);

export const createCustomQuote = (data) =>
  api.post('/custom-quotes/admin', data).then(r => r.data);

export const deleteCustomQuote = (id) =>
  api.delete(`/custom-quotes/admin/${id}`).then(r => r.data);
